<div class="dial" *ngIf="mode === 'analog'">
  <div class="dot"></div>
  <div class="sec-hand" [style.transform]="'rotate(' + secAngle + 'deg)'"></div>
  <div class="sec-hand shadow" [style.transform]="'rotate(' + secAngle + 'deg)'"></div>
  <div class="min-hand" [style.transform]="'rotate(' + minAngle + 'deg)'"></div>
  <div class="min-hand shadow" [style.transform]="'rotate(' + minAngle + 'deg)'"></div>
  <div class="hour-hand" [style.transform]="'rotate(' + hourAngle + 'deg)'"></div>
  <div class="hour-hand shadow" [style.transform]="'rotate(' + hourAngle + 'deg)'"></div>
  <span class="twelve">12</span>
  <span class="three">3</span>
  <span class="six">6</span>
  <span class="nine">9</span>
  <span class="dialline" *ngFor="let line of lines" [style.transform]="'rotate(' + 6 * line + 'deg)'"></span>
</div>
<div *ngIf="mode === 'digital'" class="digital">
  {{date | qmDateFormat: 'HH:mm:ss'}}
</div>
